"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7199],{

/***/ 2430:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "T": function() { return /* reexport */ ImageLoaderWrapper; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(9534);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(5944);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/components/ImageLoaderWrapper/ImageLoaderWrapper.tsx





/**
 * Calculates the proper height of an image with a custom width, preserving the original aspect ratio.
 *
 * @param originalHeight
 * @param originalWidth
 * @param newWidth
 */ function determineNewHeight(originalHeight, originalWidth, newWidth) {
    return Math.ceil(originalHeight / originalWidth * newWidth);
}
var ImageLoaderWrapper = function(props) {
    var height = props.height, width = props.width, grayscale = props.grayscale, format = props.format, layout = props.layout, alt = props.alt, _rszHeight = props.rszHeight, rszHeight = _rszHeight === void 0 ? true : _rszHeight, other = (0,_object_without_properties/* default */.Z)(props, [
        "height",
        "width",
        "grayscale",
        "format",
        "layout",
        "alt",
        "rszHeight"
    ]);
    var loader = function(loaderProps) {
        var q = loaderProps.quality, w = loaderProps.width, src = loaderProps.src;
        // if (/^https?:\/\//.test(src)) return src;
        // Can find the query properties here;
        // https://gitlab.azerdev.com/huz.byorbit/huz-media/-/blob/master/src/asset/index.js
        // Todo: HUZ2ERA-1106 - Seems our media server won't allow us to resize webp assets by ratio operation.
        // let url = `${src.replace(/\/+$/, '')}/?qty=${q || 75}&fmt=${format || 'webp'}&ar[r]=${width}x${height}&ar[w]=${w}`;
        // let url = `${src.replace(/\/+$/, '')}/?qty=${q || 75}&fmt=${format || 'webp'}&rsz[w]=${w}`;
        var url = "".concat(src.replace(/\/+$/, ""), "/?fmt=").concat(format || "webp", "&rsz[w]=").concat(w);
        if (rszHeight) {
            url += "&rsz[h]=".concat(determineNewHeight(height, width, w));
        }
        if (grayscale) url += "&gsc=".concat(grayscale);
        return url;
    };
    // Make sure we don't pass width and height when layout is set to 'fill'. Refer to Next/image docs.
    return layout === "fill" ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, other), {
        alt: alt,
        layout: layout,
        loader: loader
    })) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, other), {
        alt: alt,
        width: width,
        height: height,
        loader: loader
    }));
};

;// CONCATENATED MODULE: ./src/components/ImageLoaderWrapper/index.ts



/***/ }),

/***/ 9995:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "LastPlayedMenu": function() { return /* reexport */ LastPlayedMenu; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(5944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 4 modules
var emotion_styled_browser_esm = __webpack_require__(7120);
// EXTERNAL MODULE: ./src/contexts/CursorContext/Cursor.tsx
var Cursor = __webpack_require__(2746);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/useTheme.js
var useTheme = __webpack_require__(2097);
;// CONCATENATED MODULE: ./src/components/LastPlayedMenu/@editor/index.ts


var useEditorHandlers = function(name) {
    var theme = (0,useTheme/* default */.Z)();
    return (0,Cursor/* useCursorHandlers */.h)({
        name: name,
        styles: [
            {
                name: "theme_component_last_played_icon_color",
                label: "Button icon color",
                type: "color",
                default: theme.palette.primary.contrastText
            },
            {
                name: "theme_component_last_played_icon_disabled_color",
                label: "Button icon disabled color",
                type: "color",
                default: theme.palette.text.disabled
            }, 
        ],
        configuration: []
    });
};

// EXTERNAL MODULE: ./src/contexts/AppContext/index.tsx + 4 modules
var AppContext = __webpack_require__(6242);
// EXTERNAL MODULE: ./src/contexts/HighlightContext/Highlight.tsx
var Highlight = __webpack_require__(8958);
// EXTERNAL MODULE: ./src/utils/use-local-storage.ts
var use_local_storage = __webpack_require__(8714);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(9630);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(562);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Popper/Popper.js + 56 modules
var Popper = __webpack_require__(8402);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Grow/Grow.js
var Grow = __webpack_require__(1760);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Paper/Paper.js + 1 modules
var Paper = __webpack_require__(918);
// EXTERNAL MODULE: ./node_modules/@mui/base/ClickAwayListener/ClickAwayListener.js
var ClickAwayListener = __webpack_require__(3926);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/MenuList/MenuList.js + 1 modules
var MenuList = __webpack_require__(852);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/MenuItem/MenuItem.js + 2 modules
var MenuItem = __webpack_require__(5507);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/ListItemIcon/ListItemIcon.js
var ListItemIcon = __webpack_require__(9894);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Badge/Badge.js + 6 modules
var Badge = __webpack_require__(3821);
// EXTERNAL MODULE: ./src/components/Link/index.tsx
var Link = __webpack_require__(7500);
// EXTERNAL MODULE: ./src/components/Card/index.ts + 8 modules
var Card = __webpack_require__(6267);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/AccessTime.js
var AccessTime = __webpack_require__(244);
;// CONCATENATED MODULE: ./src/components/LastPlayedMenu/LastPlayedMenu.tsx
























var LastPlayedMenu_Typography = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    return (0,Highlight/* useHighlightHandlers */.R)(Typography/* default */.Z, (0,_object_spread/* default */.Z)({
        forwardedRef: ref
    }, props));
});
var IconButtonStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(IconButton/* default */.Z, {
    target: "et81o6h0"
})(function(param) {
    var theme = param.theme;
    return {
        "&.Mui-disabled svg": {
            color: theme.theme_component_last_played_icon_disabled_color || theme.palette.text.disabled
        }
    };
});
var ItemLabel = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(LastPlayedMenu_Typography, {
    target: "et81o6h1"
})(function(param) {
    var theme = param.theme;
    return {
        color: theme.theme_component_last_played_label_color || theme.palette.text.primary
    };
});
var PaperStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Paper/* default */.Z, {
    target: "et81o6h2"
})(function(param) {
    var theme = param.theme;
    return {
        backgroundColor: theme.theme_component_last_played_paper_background_color || theme.palette.background.paper
    };
});
var LastPlayedIcon = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(AccessTime/* default */.Z, {
    target: "et81o6h3"
})(function(param) {
    var theme = param.theme;
    return {
        color: theme.theme_component_last_played_icon_color || theme.palette.primary.contrastText
    };
});
var ListItemIconStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(ListItemIcon/* default */.Z, {
    target: "et81o6h4"
})(function(param) {
    var theme = param.theme;
    return {
        borderRadius: theme.shape.borderRadius,
        marginRight: theme.spacing(2),
        width: theme.spacing(4),
        aspectRatio: "1/1"
    };
});
var LastPlayedMenu = function(props) {
    var size = props.size, edge = props.edge, variant = props.variant, overlap = props.overlap;
    var theme = (0,useTheme/* default */.Z)();
    var appContext = (0,AppContext/* useAppContext */.bp)();
    var assetUrl = appContext.useConfig().assetUrl;
    var ref = (0,_sliced_to_array/* default */.Z)((0,use_local_storage/* default */.Z)("lastplayed:current", []), 1), gamesCurrent = ref[0];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,use_local_storage/* default */.Z)("lastplayed:previous", []), 2), gamesPrevious = ref1[0], setGamesPrevious = ref1[1];
    var anchorRef = react.useRef(null);
    var ref2 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), open = ref2[0], setOpen = ref2[1];
    var prevOpen = react.useRef(open);
    var labelRefs = react.useRef([]);
    // Todo: Fix labelRefs.current typescript problem.
    // @ts-ignore
    labelRefs.current = gamesCurrent.map(function(game, index) {
        var _index;
        // @ts-ignore
        return (_index = labelRefs.current[index]) !== null && _index !== void 0 ? _index : /*#__PURE__*/ react.createRef();
    });
    var getDiff = function(previousGames, currentGames) {
        var badgeCount = 0;
        if (!previousGames || !currentGames) return badgeCount;
        previousGames.forEach(function(previous) {
            currentGames.forEach(function(recent) {
                if (recent.id === previous.id) badgeCount++;
            });
        });
        return currentGames.length - badgeCount;
    };
    var handleToggle = function() {
        setOpen(function(prevOpen) {
            return !prevOpen;
        });
        if (!open) setGamesPrevious(gamesCurrent);
    };
    var handleClose = function(event) {
        // @ts-ignore
        if (event && anchorRef.current && anchorRef.current.contains(event.target)) return;
        setOpen(false);
    };
    var handleListKeyDown = function(event) {
        if (event.key === "Tab") {
            event.preventDefault();
            setOpen(false);
        } else if (event.key === "Escape") {
            setOpen(false);
        }
    };
    react.useEffect(function() {
        // Return focus to the button when we transitioned from !open -> open.
        if (anchorRef.current && prevOpen.current && !open) {
            anchorRef.current.focus();
        }
        prevOpen.current = open;
    }, [
        open
    ]);
    react.useEffect(function() {
        setGamesPrevious(gamesPrevious);
    }, []);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconButtonStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                ref: anchorRef,
                id: "last-played-select-button",
                "aria-controls": open ? "last-played-select-menu" : undefined,
                "aria-expanded": open ? "true" : undefined,
                "aria-haspopup": "true",
                size: size,
                edge: edge,
                disabled: gamesCurrent && gamesCurrent.length <= 0,
                onClick: handleToggle
            }, useEditorHandlers("Last Played Menu")), {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Badge/* default */.Z, {
                    badgeContent: getDiff(gamesPrevious, gamesCurrent),
                    max: 10,
                    color: "secondary",
                    variant: variant,
                    overlap: overlap,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LastPlayedIcon, {})
                })
            })),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Popper/* default */.Z, {
                open: open,
                anchorEl: anchorRef.current,
                role: undefined,
                placement: "bottom-end",
                transition: true,
                disablePortal: true,
                style: {
                    zIndex: 1000,
                    maxWidth: "calc(100vw - ".concat(theme.spacing(1), "px)")
                },
                children: function(param) {
                    var TransitionProps = param.TransitionProps, placement = param.placement;
                    /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grow/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, TransitionProps), {
                        style: {
                            transformOrigin: placement === "bottom-start" ? "right top" : "right bottom"
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PaperStyled, {
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ClickAwayListener/* default */.Z, {
                                onClickAway: handleClose,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuList/* default */.Z, {
                                    autoFocusItem: open,
                                    id: "last-played-select-menu",
                                    "aria-labelledby": "last-played-select-button",
                                    onKeyDown: handleListKeyDown,
                                    children: gamesCurrent === null || gamesCurrent === void 0 ? void 0 : gamesCurrent.map(function(game, index) {
                                        return game.id && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MenuItem/* default */.Z, {
                                            component: Link/* Link */.r,
                                            href: "/game/".concat(game.slug),
                                            title: game.name || undefined,
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ListItemIconStyled, {
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* CardAsset */.HW, {
                                                        src: "".concat(assetUrl).concat(game.images.cover1x1 || game.images.cover, "/"),
                                                        alt: game.name || "Cover",
                                                        width: 30,
                                                        height: 30,
                                                        layout: "responsive",
                                                        sizes: "30px"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ItemLabel, {
                                                    // @ts-ignore
                                                    ref: labelRefs.current[index],
                                                    variant: "body1",
                                                    textAlign: "left",
                                                    noWrap: true,
                                                    children: game.name
                                                })
                                            ]
                                        }, game.id);
                                    })
                                })
                            })
                        })
                    }));
                }
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/LastPlayedMenu/index.ts



/***/ }),

/***/ 830:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* reexport */ PaperColorElevation; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(9534);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(5944);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 4 modules
var emotion_styled_browser_esm = __webpack_require__(7120);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/colorManipulator.js
var colorManipulator = __webpack_require__(1796);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Paper/Paper.js + 1 modules
var Paper = __webpack_require__(918);
;// CONCATENATED MODULE: ./src/components/PaperColorElevation/PaperColorElevation.tsx







var PaperStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Paper/* default */.Z, {
    target: "e4eo54y0"
})(function(param) {
    var theme = param.theme, elevation = param.elevation;
    return {
        boxShadow: theme.shadows[elevation || 1],
        backgroundColor: theme.palette.mode === "dark" ? (0,colorManipulator/* lighten */.$n)(theme.palette.background.paper, elevation ? elevation * 0.025 : 0) : (0,colorManipulator/* darken */._j)(theme.palette.background.paper, elevation ? elevation * 0.025 : 0)
    };
});
var PaperColorElevation = function(props) {
    var children = props.children, other = (0,_object_without_properties/* default */.Z)(props, [
        "children"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PaperStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, other), {
        children: children
    }));
};

;// CONCATENATED MODULE: ./src/components/PaperColorElevation/index.ts



/***/ }),

/***/ 8958:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ useHighlightHandlers; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2097);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4794);







// Todo: Have a hard time setting the type for Component, as it can be Mui Typography or our own Link component.
var useHighlightHandlers = function(Component, props) {
    var enabledVariants = (0,_index__WEBPACK_IMPORTED_MODULE_1__/* .useHighlightContext */ .A)().enabledVariants;
    var forwardedRef = props.forwardedRef, variant = props.variant, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props, [
        "forwardedRef",
        "variant"
    ]);
    var theme = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    var element = null;
    // Todo: Not sure how to resolve this missing current ts warning.
    // @ts-ignore
    if (forwardedRef && (forwardedRef === null || forwardedRef === void 0 ? void 0 : forwardedRef.current)) {
        // Todo: Not sure how to resolve this missing current ts warning.
        // @ts-ignore
        element = forwardedRef.current;
    }
    if (element && variant && Array.isArray(enabledVariants)) {
        if (enabledVariants.includes(variant)) {
            element.style.outline = "2px dotted ".concat(theme.palette.info.main);
            element.style.outlineOffset = "-2px";
            element.style.position = "relative";
            if (!element.querySelector(".typographyBadge")) {
                var badge = document.createElement("div");
                badge.classList.add("typographyBadge");
                badge.style.position = "absolute";
                badge.style.top = theme.spacing(-0.5);
                badge.style.right = theme.spacing(-0.5);
                badge.style.backgroundColor = theme.palette.info.main;
                badge.style.borderRadius = "".concat(theme.shape.borderRadius, "px");
                badge.style.color = theme.palette.info.contrastText;
                badge.style.fontSize = "10px";
                badge.style.lineHeight = "10px";
                badge.style.padding = theme.spacing(0.5, 1);
                badge.style.boxShadow = theme.shadows[1];
                badge.style.textTransform = "capitalize";
                badge.innerText = [
                    "contained",
                    "text",
                    "outlined"
                ].includes(variant) ? "button" : variant;
                element.appendChild(badge);
            }
        } else {
            var ref;
            element.style.outline = "unset";
            (ref = element.querySelector(".typographyBadge")) === null || ref === void 0 ? void 0 : ref.remove();
        }
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(Component, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, rest), {
        variant: variant,
        ref: forwardedRef
    }));
};


/***/ })

}]);